import {FC, useEffect} from 'react';
import {Outlet} from 'react-router-dom';
import {useResetRecoilState} from 'recoil';
import {toolbarServiceRequestSearchStringArchived} from '../../store/service-requests/atoms';

export const ServiceRequestsLayout: FC = () => {
  const reset = useResetRecoilState(toolbarServiceRequestSearchStringArchived);

  useEffect(() => {
    return () => reset();
  }, []);

  return <Outlet />;
};
